import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(
    document.cookie.indexOf('cookieConsent=true') === -1,
  );

  useEffect(() => {
    document.body.style.overflow = isVisible ? 'hidden' : '';
  }, [isVisible]);

  const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
  };

  const handleAcceptAll = () => {
    setIsVisible(false);
    setCookie('cookieConsent', 'true', 365);
  };

  const handleAcceptNecessary = () => {
    setIsVisible(false);
    setCookie('cookieConsent', 'necessary', 365);
  };

  const handleDeclineAll = () => {
    setIsVisible(false);
    setCookie('cookieConsent', 'false', 365);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end justify-center z-50">
      <div className="bg-[#F2994A] rounded-2xl shadow-xl p-4 md:p-6 max-w-2xl w-full mx-4 relative">
        {/* <button
          onClick={() => setIsVisible(false)}
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-900"
        >
          ✕
        </button> */}
        <h3 className="text-xl font-semibold text-gray-800 mb-2">
          We care about your privacy
        </h3>
        <p className="text-gray-600 text-sm mb-4">
          KnowQuest uses cookies and similar technologies to enhance your
          experience. By clicking "Accept All", you agree to share information
          with our partners for personalized content and services. You can
          manage your preferences anytime or decline all to opt out of
          personalization.
        </p>
        <div className="flex flex-col md:flex-row md:space-x-3 space-y-2 md:space-y-0">
          <button
            onClick={handleAcceptAll}
            className="bg-white text-[#0E1834] font-medium py-2 px-4 rounded-lg  transition"
          >
            Accept All
          </button>
          <button
            onClick={handleAcceptNecessary}
            className="bg-white text-[#0E1834] font-medium py-2 px-4 rounded-lg  transition"
          >
            Accept Necessary
          </button>
          <button
            onClick={handleDeclineAll}
            className="bg-white text-[#0E1834] font-medium py-2 px-4 rounded-lg  transition"
          >
            Decline All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
